<template>
  <a-drawer
      v-model:visible="show"
      :closable="false"
      :footer-style="{ textAlign: 'left' }"
      :mask="false"
      :style="{
      paddingLeft: 0,
      paddingRight: 0,
    }"
      placement="right"
      width="400px"
  >
    <a-spin :spinning="priceSpinning">
      <a-tabs v-model:activeKey="priceActiveKey">
        <a-tab-pane key="1" tab="改价">
          <div class="editPrice">
            <!-- 房间信息 -->
            <div class="price_info">
              <div class="info_left">
                <a-image
                    :preview="false"
                    :src="
                    imgCut(
                      housePriceData.image ? housePriceData.image : companyLogo,
                      'xl'
                    )
                  "
                    height="60px"
                    width="80px"
                />
              </div>
              <div class="info_right">
                <div class="right_date">
                  {{ housePriceData.name }}
                </div>
                <div v-if="houseType == 2" class="right_group">
                  {{ housePriceData.gname }}
                </div>
                <!-- <div class="right_nights">
                      共 {{ selHouse.date.length }} 晚
                    </div> -->
              </div>
            </div>
            <div class="price_house_name">
              <a-range-picker
                  v-model:value="priceDates"
                  :allowClear="false"
                  :disabledDate="handleDisabledDate"
                  @change="priceDateChange"
              />
              共 {{ selHouse.date.length }} 晚
            </div>
            <!-- 周 -->
            <div class="price_week">
              <a-checkbox-group
                  v-model:value="priceSelWeek"
                  style="width: 100%"
              >
                <a-checkbox
                    v-for="item in 7"
                    :key="item"
                    :disabled="!priceSelWeek.includes(item)"
                    :value="item"
                    @change="PriceCheckboxChange"
                >
                  周{{ "日一二三四五六".charAt(item - 1) }}
                </a-checkbox>
              </a-checkbox-group>
            </div>
            <!-- 价格 -->
            <div class="price_edit">
              <!-- 一键改价 -->
              <div class="edit_cell">
                <div class="cell_left f-c-bf">一键改价</div>
                <div class="cell_right">
                  <a-input-number
                      v-model:value="selHouse.price"
                      :max="9999"
                      :min="0"
                      placeholder="价格"
                      style="width: 200px"
                      @change="handleOneKey"
                  />
                </div>
              </div>
              <!-- PMS -->
              <div class="edit_cell">
                <div class="cell_left f-c-bf">
                  {{ housePriceData.name }}
                </div>
                <div class="cell_right">
                  <a-input-number
                      v-model:value="housePriceData.price"
                      :max="9999"
                      :min="0"
                      placeholder="价格"
                      style="width: 200px"
                  />
                </div>
              </div>
              <!-- OTA -->
              <div
                  v-for="(item, index) in housePriceData.child"
                  :key="index"
                  :class="{ isNoEdit: item.is_edit == 0 }"
                  class="edit_cell"
              >
                <div class="cell_left f-c-b">
                  <div class="left_icon">
                    <a-avatar :src="item.logo" size="small"/>
                  </div>
                  <div class="left_name t-h-2">
                    {{ item.ota_name }}({{ item.ota_com_name }})
                  </div>
                </div>
                <div v-if="item.is_edit != 0" class="cell_right">
                  <a-input
                      v-model:value="item.price"
                      :disabled="item.is_edit == 0"
                      placeholder="价格"
                      style="width: 200px"
                      type="number"
                  />
                </div>
              </div>
            </div>
          </div>
        </a-tab-pane>
        <a-tab-pane key="2" tab="渠道房态">
          <div class="editPrice">
            <!-- 房间信息 -->
            <div class="price_info">
              <div class="info_left">
                <a-image
                    :preview="false"
                    :src="
                    imgCut(
                      housePriceData.image ? housePriceData.image : companyLogo,
                      'xl'
                    )
                  "
                    height="60px"
                    width="80px"
                />
              </div>
              <div class="info_right">
                <div class="right_date">
                  {{ housePriceData.name }}
                </div>
                <div v-if="houseType == 2" class="right_group">
                  {{ housePriceData.gname }}
                </div>
                <!-- <div class="right_nights">
                      共 {{ selHouse.date.length }} 晚
                    </div> -->
              </div>
            </div>
            <div class="price_house_name">
              <a-range-picker
                  v-model:value="priceDates"
                  :disabledDate="handleDisabledDate"
                  @change="priceDateChange"
              />
              共 {{ selHouse.date.length }} 晚
            </div>
            <!-- 周 -->
            <div class="price_week">
              <a-checkbox-group
                  v-model:value="priceSelWeek"
                  style="width: 100%"
              >
                <a-checkbox
                    v-for="item in 7"
                    :key="item"
                    :disabled="!priceSelWeek.includes(item)"
                    :value="item"
                    @change="PriceCheckboxChange"
                >
                  周{{ "日一二三四五六".charAt(item - 1) }}
                </a-checkbox>
              </a-checkbox-group>
            </div>

            <!-- 锁房 开房 -->
            <div class="price_edit">
              <!-- 一键改变 -->
              <div class="edit_cell">
                <div class="cell_left f-c-bf">一键修改</div>
                <div class="cell_right">
                  <div class="right_switch">
                    <div
                        :class="{
                        isSwitch: oneKeyStatus == 1 ? true : false,
                      }"
                        class="switch_open"
                        @click="handleOneKeyStatus(1)"
                    >
                      打开
                    </div>
                    <div
                        :class="{
                        isSwitch: oneKeyStatus == 3 ? true : false,
                      }"
                        class="switch_close"
                        @click="handleOneKeyStatus(3)"
                    >
                      关闭
                    </div>
                    <div
                        :class="{
                        isSwitch: oneKeyStatus == 0 ? true : false,
                      }"
                        class="switch_no"
                        @click="handleOneKeyStatus(0)"
                    >
                      不变
                    </div>
                  </div>
                </div>
              </div>
              <!-- PMS -->
              <div class="edit_cell">
                <div class="cell_left f-c-bf">
                  {{ housePriceData.name }}
                </div>
                <div class="cell_right">
                  <div class="right_switch">
                    <div
                        :class="{
                        isSwitch: housePriceData.status == 1 ? true : false,
                      }"
                        class="switch_open"
                        @click="housePriceData.status = 1"
                    >
                      打开
                    </div>
                    <div
                        :class="{
                        isSwitch: housePriceData.status == 3 ? true : false,
                      }"
                        class="switch_close"
                        @click="housePriceData.status = 3"
                    >
                      关闭
                    </div>
                    <div
                        :class="{
                        isSwitch: housePriceData.status == 0 ? true : false,
                      }"
                        class="switch_no"
                        @click="housePriceData.status = 0"
                    >
                      不变
                    </div>
                  </div>
                </div>
              </div>
              <!-- OTA -->
              <div
                  v-for="(item, index) in housePriceData.child"
                  :key="index"
                  class="edit_cell"
              >
                <div class="cell_left f-c-b">
                  <div class="left_icon">
                    <a-avatar :src="item.logo" size="small"/>
                  </div>
                  <div class="left_name t-h-2">
                    {{ item.ota_name }}({{ item.ota_com_name }})
                  </div>
                </div>
                <div v-if="item.is_edit != 0" class="cell_right">
                  <div class="right_switch">
                    <div
                        :class="{
                        isSwitch: item.status == 1 ? true : false,
                      }"
                        class="switch_open"
                        @click="item.status = 1"
                    >
                      打开
                    </div>
                    <div
                        :class="{
                        isSwitch: item.status == 3 ? true : false,
                      }"
                        class="switch_close"
                        @click="item.status = 3"
                    >
                      关闭
                    </div>
                    <div
                        :class="{
                        isSwitch: item.status == 0 ? true : false,
                      }"
                        class="switch_no"
                        @click="item.status = 0"
                    >
                      不变
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </a-tab-pane>
      </a-tabs>
    </a-spin>
    <template #footer>
      <a-button type="primary" @click="handleConfirm">确定</a-button>
      <a-button style="margin-left: 8px" @click="handleClose">关闭</a-button>
    </template>
  </a-drawer>
</template>

<script>
import dayjs from "dayjs";
import {onMounted, reactive, toRefs, watch} from "vue";
import {getDetailsPrice, housePirceEdit, houseStatusEdit,} from "@/api/api";
import {message} from "ant-design-vue";
import useUtils from "@/hooks/useUtils.js";

export default {
  props: {
    priceDate: {
      default: [],
    },
    type: {
      default: 1,
    },
    hid: {
      default: "",
    },
    rid: {
      default: "",
    },
  },

  setup(props, content) {
    const {diffDate, imgCut} = useUtils();
    // 改价
    const prices = reactive({
      companyLogo: JSON.parse(sessionStorage.getItem("companyInfo") || '{}').logo || '',
      show: true,
      selHouse: {
        hid: props.hid,
        rid: props.rid,
        date: [],
        price: "",
        type: 1,
      },
      ota_id: undefined,
      cota_id: undefined,
      houseType: props.type, // 1 房型 2 房间
      // 改价
      priceActiveKey: "1",
      priceSelWeek: [],
      // 周几回调
      PriceCheckboxChange(v) {
        let val = v.target.value;
        let days = prices.selHouse.date;
        days.forEach((item, index) => {
          if (val == dayjs(item).day() + 1) {
            days.splice(index, 1);
          }
        });
      },

      housePriceData: "",
      priceDates: [],
      // 时间回调
      priceDateChange(a, b) {
        prices.selHouse.date = diffDate(b[0], b[1]);
        content.emit("changeDate", prices.selHouse.date);
        let days = prices.selHouse.date;
        prices.priceSelWeek = Array.from(
            new Set(days.map((item) => dayjs(item).day() + 1))
        );
        prices.getPriceDetails();
      },
      // 禁用时间
      handleDisabledDate(v) {
        return dayjs(v).format("YYYY-MM-DD") < dayjs().format("YYYY-MM-DD");
      },
      priceSpinning: false,
      // 获取房价详情
      getPriceDetails() {
        prices.priceSpinning = true;
        getDetailsPrice({
          begin: prices.selHouse.date[0],
          end: prices.selHouse.date[prices.selHouse.date.length - 1],
          hid: props.type == 2 ? props.hid : "",
          rid: props.type == 1 ? props.rid : "",
        })
            .then((res) => {
              if (props.type == 1) {
                prices.housePriceData = {
                  ...res.data.room,
                  price: "",
                  status: "",
                  child: res.data.room?.child.map((item) => {
                    return {...item, price: "", status: ""};
                  }),
                };
              } else {
                prices.housePriceData = {
                  ...res.data.house,
                  price: "",
                  status: "",
                  child: res.data.house?.child.map((item) => {
                    return {...item, price: "", status: ""};
                  }),
                };
              }
            })
            .finally(() => {
              prices.priceSpinning = false;
            });
      },
      // 一键改价
      handleOneKey(v) {
        prices.housePriceData = {
          ...prices.housePriceData,
          price: v,
          child: prices.housePriceData.child.map((item) => {
            return {
              ...item,
              price: v,
            };
          }),
        };
      },
      // 确定
      handleConfirm() {
        // 1改价 2锁房开房
        if (prices.priceActiveKey == 1) {
          let params = {
            [props.type == 1 ? "rid" : "hid"]:
                props.type == 1
                    ? prices.housePriceData.rid
                    : prices.housePriceData.hid,
            price: prices.housePriceData.price,
            child: prices.housePriceData.child.map((item) => {
              return {
                ota_house_id: item.ota_house_id,
                price: item.price,
              };
            }),
          };

          housePirceEdit({
            price_list: JSON.stringify(params),
            dates: prices.selHouse.date.join(","),
            type: props.type == 1 ? 2 : 1,
          }).then((res) => {
            message.success(res.msg);
            // prices.priceShow = false;
            // prices.selHouse.id = "";
            // prices.selHouse.date = [];
            // prices.selHouse.price = "";
            // houses.init();
            content.emit("refreshAmendPrice");
          });
        } else {
          let params = {
            [props.type == 1 ? "rid" : "hid"]:
                props.type == 1
                    ? prices.housePriceData.rid
                    : prices.housePriceData.hid,
            status: prices.housePriceData.status,
            child: prices.housePriceData.child.map((item) => {
              return {
                ota_house_id: item.ota_house_id,
                status: item.status,
              };
            }),
          };
          houseStatusEdit({
            price_list: JSON.stringify(params),
            dates: prices.selHouse.date.join(","),
            type: props.type == 1 ? 2 : 1,
          }).then((res) => {
            message.success(res.msg);
            // prices.priceShow = false;
            // prices.selHouse.id = "";
            // prices.selHouse.date = [];
            // prices.oneKeyStatus = "";
            // houses.init();
            content.emit("refreshAmendPrice");
          });
        }
      },
      housePriceInfo: "",

      // 开房 锁房
      oneKeyStatus: "",
      // 一键不变
      handleOneKeyStatus(status) {
        prices.oneKeyStatus = status;
        prices.housePriceData = {
          ...prices.housePriceData,
          status,
          child: prices.housePriceData.child.map((item) => {
            return {
              ...item,
              status: status,
            };
          }),
        };
      },
      // 取消
      handleClose() {
        prices.show = false;
        setTimeout(() => {
          content.emit("closeAmendPrice");
        }, 500);
      },
    });

    // 计算两个日期之间的全部日期
    const betweenDates = (startDate, endDate) => {
      let daysList = [];
      const start = dayjs(startDate).format("YYYY-MM-DD");
      const end = dayjs(endDate).format("YYYY-MM-DD");
      const day = dayjs(end).diff(start, "day");
      daysList.push(start);
      for (let i = 1; i <= day; i++) {
        daysList.push(dayjs(start).add(i, "day").format("YYYY-MM-DD"));
      }
      return daysList;
    };

    function init() {
      prices.priceDates = props.priceDate;
      prices.selHouse.date = betweenDates(
          props.priceDate[0],
          props.priceDate[1]
      );
      let days = prices.selHouse.date;
      prices.priceSelWeek = Array.from(
          new Set(days.map((item) => dayjs(item).day() + 1))
      );
      prices.getPriceDetails();
    }

    watch(props, () => {
      init();
    });

    onMounted(() => {
      init();
    });

    return {
      ...toRefs(prices),
      imgCut,
    };
  },
};
</script>

<style lang="scss">
// 改价
.editPrice {
  .price_info {
    display: flex;
    padding-bottom: 10px;
    border-bottom: 1px solid #f3f3f3;
    margin-bottom: 10px;

    .info_left {
      border-radius: 5px;
      overflow: hidden;
      margin-right: 10px;
    }

    .info_right {
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .right_date {
        padding: 5px;
        border-radius: 4px;
        background-color: #f7f8fa;
      }

      .right_group {
      }

      .right_nights {
      }
    }
  }

  .price_house_name {
    margin-bottom: 10px;
    // padding: 5px;
    // border-radius: 4px;
    // background-color: #f7f8fa;
  }

  .price_week {
    border-bottom: 1px solid #f3f3f3;
    padding-bottom: 10px;
    margin-bottom: 10px;
  }

  .price_edit {
    .isNoEdit {
      cursor: not-allowed;
    }

    .edit_cell {
      display: flex;
      margin-bottom: 10px;

      .cell_left {
        flex: 4;
        display: flex;
        align-items: center;
        margin-right: 15px;

        .left_icon {
          margin-right: 6px;
        }

        .left_name {
          line-height: 1.2;
        }
      }

      .cell_right {
        flex: 6;

        .right_switch {
          display: flex;
          border: 1px solid #f3f3f3;
          border-radius: 4px;
          width: 180px;
          height: 32px;
          color: #ccc;
          overflow: hidden;
          cursor: pointer;

          .switch_open {
            display: flex;
            justify-content: center;
            align-items: center;
            flex: 1;
            border-right: 1px solid #f3f3f3;
          }

          .switch_close {
            display: flex;
            justify-content: center;
            align-items: center;
            flex: 1;
            border-right: 1px solid #f3f3f3;
          }

          .switch_no {
            display: flex;
            justify-content: center;
            align-items: center;
            flex: 1;
          }

          .isSwitch {
            background-color: #0094ff;
            color: #fff;
          }
        }
      }
    }
  }
}
</style>